import { DataCacheState } from '../state';
import { useSelector } from 'react-redux';
import { RootState } from '..';

export const useLoadCache = (): Partial<DataCacheState> =>
  useSelector((state: RootState) => state.DataCache);

export const useLoadStaffRoleCache = (): any[] =>
  useSelector((state: RootState) => state.DataCache.staffRoleCache || []);
